import { persistReducer } from 'redux-persist';
import persistConfig from '../config/persistConfig';
import { AnyAction, combineReducers } from 'redux';
import {
    authSlice,
    stepperSlice,
    homeSlice,
    rateFinderSlice,
    coreTaxDetailsSlice,
    riskLocatorSlice,
    scheduleDetailsSlice,
    insurerJurisdictionSlice,
    reviewAndPublishSlice,
    userProfileSlice,
    adminMenuSlice,
    adminSlice,
} from './coreReducers';

const rootReducer = persistReducer<ReturnType<any>, AnyAction>(
    persistConfig,
    combineReducers({
        authSlice,
        stepperSlice,
        homeSlice,
        rateFinderSlice,
        coreTaxDetailsSlice,
        riskLocatorSlice,
        insurerJurisdictionSlice,
        scheduleDetailsSlice,
        reviewAndPublishSlice,
        userProfileSlice,
        adminMenuSlice,
        adminSlice,
    }),
);

export default rootReducer;
